import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
function AdditionalInfo({
  children,
  padding = "all",
  ...props
}) {
  return /* @__PURE__ */ jsx(AdditionalInfoStyled, {
    $padding: padding,
    ...props,
    children
  });
}
const AdditionalInfoStyled = styled.div.withConfig({
  displayName: "AdditionalInfoStyled",
  componentId: "sc-kuakuj-0"
})(["", " padding:", ";border-top:1px solid ", ";color:", ";"], textStyles.uiTextS, (props) => props.$padding === "all" ? "var(--card-content-padding)" : "0", token.gray100a, token.colorText);
export {
  AdditionalInfo
};
//# sourceMappingURL=AdditionalInfo.js.map
